import React from "react";
import KunjunganRawatJalanContext from "./context/context";
import KunjunganRawatJalanWrapper from "./ui/KunjunganRawatJalanWrapper";

function KunjunganRawatJalan() {
  return (
    <KunjunganRawatJalanContext>
      <KunjunganRawatJalanWrapper />
    </KunjunganRawatJalanContext>
  );
}

export default KunjunganRawatJalan;
